(() => {
  let pending = false;
  const homes = new WeakMap();
  const desktop = matchMedia('(min-width: 990px)');
  function scan() {
    pending = false;
    const root = document.querySelector('main [data-section-type="product"]');
    if (!root) return;
    if (location.pathname === '/products/minimalist-nordic-wall-clock-with-silent-quartz-movement') {
      const imageReplacements = [
        ['zorura-nomira-ranked-size-20261020.png', 'https://cdn.shopify.com/s/files/1/1059/6469/9808/files/zorura-nomira-size-rounded-draft-20261023.png?v=1792790609'],
        ['zorura-nomira-ranked-room-on-20261020.png', 'https://cdn.shopify.com/s/files/1/1059/6469/9808/files/zorura-nomira-sideboard-30cm-corrected-draft-20261023.png?v=1792792001', 'Nomira Medium 30 cm clock above a walnut console'],
        ['zorura-nomira-ranked-room-second-20261020.png', 'https://cdn.shopify.com/s/files/1/1059/6469/9808/files/zorura-nomira-reading-nook-30cm-draft-20261023.png?v=1792791497', 'Nomira Medium 30 cm clock beside a reading chair']
      ];
      root.querySelectorAll('img, source, a').forEach(element => {
        for (const attribute of Array.from(element.attributes)) {
          const replacement = imageReplacements.find(([oldName]) => attribute.value.includes(oldName));
          if (replacement) {
            element.setAttribute(attribute.name, replacement[1]);
            if (element.tagName === 'IMG' && replacement[2]) element.alt = replacement[2];
          }
        }
      });
    }
    const detail = document.querySelector('.zpc-details');
    const content = root.querySelector('.product__meta-content');
    if (detail && content) {
      if (!homes.has(detail)) {
        const home = document.createComment('product-details-home');
        detail.before(home);
        homes.set(detail, home);
      }
      if (desktop.matches && detail.parentElement !== content) content.append(detail);
      if (!desktop.matches && detail.parentNode !== homes.get(detail).parentNode) homes.get(detail).after(detail);
    }
    root.querySelectorAll('[data-zpc-size-labels]').forEach(script => {
      let labels;
      try { labels = JSON.parse(script.textContent); } catch { return; }
      root.querySelectorAll('select option').forEach(option => {
        const label = labels[option.value];
        if (label && option.textContent !== label) option.textContent = label;
      });
      root.querySelectorAll('[data-option-value]').forEach(button => {
        const label = labels[button.dataset.optionValue];
        if (!label) return;
        const text = Array.from(button.childNodes).find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
        if (text && text.textContent.trim() !== label) text.textContent = label;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      });
      root.querySelectorAll('[data-selected-value-for-option]').forEach(label => {
        const replacement = labels[label.textContent.trim()];
        if (replacement) label.textContent = replacement;
      });
    });
    const gallery = root.querySelector('.above-mobile[data-desktop-gallery-layout="thumbnails"]');
    const media = gallery?.querySelector('.product__media');
    if (media && gallery.querySelectorAll('[data-thumbnail-id]').length > 1 && !media.querySelector('[data-zpc-gallery-direction]')) {
      for (const [direction, text, symbol] of [[-1, 'Previous product image', '‹'], [1, 'Next product image', '›']]) {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'zpc-gallery-arrow';
        button.dataset.zpcGalleryDirection = String(direction);
        button.setAttribute('aria-label', text); button.textContent = symbol;
        media.append(button);
      }
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(scan);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-zpc-gallery-direction]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    const gallery = button.closest('.product__media-container');
    const thumbnails = Array.from(gallery.querySelectorAll('[data-thumbnail-id]'));
    const visible = gallery.querySelector('.product__media-item:not(.hidden)');
    const index = thumbnails.findIndex(t => t.dataset.thumbnailId === visible?.dataset.mediaItemId);
    const next = (Math.max(0, index) + Number(button.dataset.zpcGalleryDirection) + thumbnails.length) % thumbnails.length;
    thumbnails[next]?.click();
  }, true);
  function start() {
    scan();
    const observerOptions = {childList:true,subtree:true};
    if (location.pathname === '/products/minimalist-nordic-wall-clock-with-silent-quartz-movement') {
      observerOptions.attributes = true;
      observerOptions.attributeFilter = ['src','srcset','href','data-src','data-srcset','data-zoom-src'];
    }
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, observerOptions);
    desktop.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
